import { ProjectIconKeys } from "@productlane/lib/src/project-icon-keys"

import type { IconType } from "."
import { AccessibilityIcon } from "./project/accessibility-icon"
import { AfricaIcon } from "./project/africa-icon"
import { AiIcon } from "./project/ai-icon"
import { AiAppIcon } from "./project/aiapp-icon"
import { AiDocumentIcon } from "./project/aidocument-icon"
import { AirplaneIcon } from "./project/airplane-icon"
import { AirTagIcon } from "./project/airtag-icon"
import { AiWritingIcon } from "./project/aiwriting-icon"
import { AlarmIcon } from "./project/alarm-icon"
import { AlarmClockIcon } from "./project/alarmclock-icon"
import { AlarmDeleteIcon } from "./project/alarmdelete-icon"
import { AlertIcon } from "./project/alert-icon"
import { AmericanFootBallIcon } from "./project/americanfootball-icon"
import { AnchorIcon } from "./project/anchor-icon"
import { AndroidIcon } from "./project/android-icon"
import { AnonymousIcon } from "./project/anonymous-icon"
import { AnthropicIcon } from "./project/anthropic-icon"
import { AppleIcon } from "./project/apple-icon"
import { AsiaIcon } from "./project/asia-icon"
import { AsteriskIcon } from "./project/asterisk-icon"
import { AstronautIcon } from "./project/astronaut-icon"
import { AttachmentIcon } from "./project/attachment-icon"
import { AustraliaIcon } from "./project/australia-icon"
import { Auth0Icon } from "./project/auth0-icon"
import { AutomationIcon } from "./project/automation-icon"
import { BandageIcon } from "./project/bandage-icon"
import { BankIcon } from "./project/bank-icon"
import { BarChartIcon } from "./project/bar-chart-icon"
import { BarGraphIcon } from "./project/bargraph-icon"
import { BasketIcon } from "./project/basket-icon"
import { BasketballIcon } from "./project/basketball-icon"
import { BatteryIcon } from "./project/battery-icon"
import { BedIcon } from "./project/bed-icon"
import { BikeIcon } from "./project/bike-icon"
import { BinocularIcon } from "./project/binocular-icon"
import { BiscuitIcon } from "./project/biscuit-icon"
import { BitcoinIcon } from "./project/bitcoin-icon"
import { BlockquoteIcon } from "./project/blockquote-icon"
import { BluetoothIcon } from "./project/bluetooth-icon"
import { BoltIcon } from "./project/bolt-icon"
import { BonesIcon } from "./project/bones-icon"
import { BookIcon } from "./project/book-icon"
import { BookmarkIcon } from "./project/bookmark-icon"
import { BookOpenIcon } from "./project/bookopen-icon"
import { BoomboxIcon } from "./project/boombox-icon"
import { BowlingBallIcon } from "./project/bowlingball-icon"
import { BoxIcon } from "./project/box-icon"
import { BoxOpenIcon } from "./project/boxopen-icon"
import { BrainIcon } from "./project/brain-icon"
import { BrickIcon } from "./project/brick-icon"
import { BriefcaseIcon } from "./project/briefcase-icon"
import { BrushIcon } from "./project/brush-icon"
import { BucketIcon } from "./project/bucket-icon"
import { BugIcon } from "./project/bug-icon"
import { BurgerIcon } from "./project/burger-icon"
import { BusIcon } from "./project/bus-icon"
import { CalculatorIcon } from "./project/calculator-icon"
import { CalendarIcon } from "./project/calendar-icon"
import { CameraIcon } from "./project/camera-icon"
import { CameraAiIcon } from "./project/cameraai-icon"
import { CarIcon } from "./project/car-icon"
import { CarPoolIcon } from "./project/carpool-icon"
import { CartIcon } from "./project/cart-icon"
import { ChartIcon } from "./project/chart-icon"
import { ChatIcon } from "./project/chat-icon"
import { ChatLineIcon } from "./project/chatline-icon"
import { ChecklistIcon } from "./project/checklist-icon"
import { ChemistIcon } from "./project/chemist-icon"
import { ChipIcon } from "./project/chip-icon"
import { ChromeIcon } from "./project/chrome-icon"
import { ClaudeIcon } from "./project/claude-icon"
import { ClickButtonIcon } from "./project/clickbutton-icon"
import { ClockIcon } from "./project/clock-icon"
import { ClockOutlineIcon } from "./project/clockoutline-icon"
import { ClothHangerIcon } from "./project/clothhanger-icon"
import { CloudIcon } from "./project/cloud-icon"
import { CodeBlockIcon } from "./project/codeblock-icon"
import { CoffeeIcon } from "./project/coffee-icon"
import { CommentIcon } from "./project/comment-icon"
import { ComodoreIcon } from "./project/comodore-icon"
import { CompassIcon } from "./project/compass-icon"
import { ComputerIcon } from "./project/computer-icon"
import { ConeIcon } from "./project/cone-icon"
import { ConnectedIcon } from "./project/connected-icon"
import { ConstructionBarrierIcon } from "./project/constructionbarrier-icon"
import { ConversationIcon } from "./project/conversation-icon"
import { CookieIcon } from "./project/cookie-icon"
import { CraneIcon } from "./project/crane-icon"
import { CreditCardIcon } from "./project/credit-card-icon"
import { CrossIcon } from "./project/cross-icon"
import { CrownIcon } from "./project/crown-icon"
import { CrystalBallIcon } from "./project/crystalball-icon"
import { CubeIcon } from "./project/cube-icon"
import { CursorIcon } from "./project/cursor-icon"
import { CustomViewIcon } from "./project/customview-icon"
import { DashboardIcon } from "./project/dashboard-icon"
import { DatabaseIcon } from "./project/database-icon"
import { DesignToolsIcon } from "./project/design-tools-icon"
import { DesktopWindowIcon } from "./project/desktopwindow-icon"
import { DiagramIcon } from "./project/diagram-icon"
import { DiceIcon } from "./project/dice-icon"
import { DinoIcon } from "./project/dino-icon"
import { DirectionIcon } from "./project/direction-icon"
import { DiscordIcon } from "./project/discord-icon"
import { DnaIcon } from "./project/dna-icon"
import { DollarIcon } from "./project/dollar-icon"
import { DollarBillIcon } from "./project/dollarbill-icon"
import { DumbbellIcon } from "./project/dumbbell-icon"
import { EdgeIcon } from "./project/edge-icon"
import { EducationIcon } from "./project/education-icon"
import { ElectricPlugIcon } from "./project/electricplug-icon"
import { EmailIcon } from "./project/email-icon"
import { EraserIcon } from "./project/eraser-icon"
import { EthereumIcon } from "./project/ethereum-icon"
import { EuroIcon } from "./project/euro-icon"
import { EuropeIcon } from "./project/europe-icon"
import { ExclamationMarkIcon } from "./project/exclamationmark-icon"
import { ExtinguisherIcon } from "./project/extinguisher-icon"
import { FaceFlatSmileIcon } from "./project/face-flat-smile-icon"
import { FaceHeartEyesIcon } from "./project/face-heart-eyes-icon"
import { FaceIcon } from "./project/face-icon"
import { FaceIdIcon } from "./project/face-id-icon"
import { FaceMaskIcon } from "./project/face-mask-icon"
import { FaceMonocleIcon } from "./project/face-monocle-icon"
import { FaceStarEyesIcon } from "./project/face-star-eyes-icon"
import { FaceSunglassesIcon } from "./project/face-sunglasses-icon"
import { FaceSurpriseIcon } from "./project/face-surprise-icon"
import { FaceTiredIcon } from "./project/face-tired-icon"
import { FaceTongueIcon } from "./project/face-tongue-icon"
import { FactoryIcon } from "./project/factory-icon"
import { FavoriteIcon } from "./project/favorite-icon"
import { FeatherIcon } from "./project/feather-icon"
import { FigmaIcon } from "./project/figma-icon"
import { FireIcon } from "./project/fire-icon"
import { FirefoxIcon } from "./project/firefox-icon"
import { FlagIcon } from "./project/flag-icon"
import { FlashlightIcon } from "./project/flashlight-icon"
import { FloppyDiskIcon } from "./project/floppydisk-icon"
import { FlowerIcon } from "./project/flower-icon"
import { FolderIcon } from "./project/folder-icon"
import { FootPrintIcon } from "./project/footprint-icon"
import { GarageIcon } from "./project/garage-icon"
import { GearsIcon } from "./project/gears-icon"
import { GitHubIcon } from "./project/github-icon"
import { GitLabIcon } from "./project/gitlab-icon"
import { GolfIcon } from "./project/golf-icon"
import { GooglePlayIcon } from "./project/googleplay-icon"
import { HackIcon } from "./project/hack-icon"
import { HealthIcon } from "./project/health-icon"
import { HearIcon } from "./project/hear-icon"
import { HeartIcon } from "./project/heart-icon"
import { HomeIcon } from "./project/home-icon"
import { HourglassIcon } from "./project/hourglass-icon"
import { ImageIcon } from "./project/image-icon"
import { InboxIcon } from "./project/inbox-icon"
import { InitiativeIcon } from "./project/initiative-icon"
import { IntercomIcon } from "./project/intercom-icon"
import { IssueStatusBacklogIcon } from "./project/issuestatusbacklog-icon"
import { IssueStatusDoneIcon } from "./project/issuestatusdone-icon"
import { IssueStatusReviewIcon } from "./project/issuestatusreview-icon"
import { IssueStatusStartedIcon } from "./project/issuestatusstarted-icon"
import { IssueStatusTodoIcon } from "./project/issuestatustodo-icon"
import { IssueStatusTriageIcon } from "./project/issuestatustriage-icon"
import { JerseyIcon } from "./project/jersey-icon"
import { JoystickIcon } from "./project/joystick-icon"
import { JudgeIcon } from "./project/judge-icon"
import { LabelIcon } from "./project/label-icon"
import { LadderIcon } from "./project/ladder-icon"
import { LeafIcon } from "./project/leaf-icon"
import { LightBulbIcon } from "./project/light-bulb-icon"
import { LinearIcon } from "./project/linear-icon"
import { LinkIcon } from "./project/link-icon"
import { LockIcon } from "./project/lock-icon"
import { LockerRoomIcon } from "./project/lockerroom-icon"
import { MacIcon } from "./project/mac-icon"
import { MacOSIcon } from "./project/macos-icon"
import { MagicWandIcon } from "./project/magicwand-icon"
import { MagnetIcon } from "./project/magnet-icon"
import { MaskIcon } from "./project/mask-icon"
import { MegaphoneIcon } from "./project/megaphone-icon"
import { MetaIcon } from "./project/meta-icon"
import { MicIcon } from "./project/mic-icon"
import { MicrosoftTeamsIcon } from "./project/microsoftteams-icon"
import { MilestoneNoneIcon } from "./project/milestonenone-icon"
import { MilestoneStatusDoneIcon } from "./project/milestonestatusdone-icon"
import { MilestoneStatusPlannedIcon } from "./project/milestonestatusplanned-icon"
import { MilestoneStatusStartedIcon } from "./project/milestonestatusstarted-icon"
import { MilitaryTruckIcon } from "./project/militarytruck-icon"
import { MobilePhoneIcon } from "./project/mobile-phone-icon"
import { ModemIcon } from "./project/modem-icon"
import { MoneyStackIcon } from "./project/moneystack-icon"
import { MoonIcon } from "./project/moon-icon"
import { MountainIcon } from "./project/mountain-icon"
import { MovingStaircaseIcon } from "./project/movingstaircase-icon"
import { MusicKeyIcon } from "./project/music-key-icon"
import { MusicTapeIcon } from "./project/musictape-icon"
import { MyIssuesIcon } from "./project/myissues-icon"
import { NetworkIcon } from "./project/network-icon"
import { NorthAmericaIcon } from "./project/north-america-icon"
import { NotePadIcon } from "./project/notepad-icon"
import { NotifiedIcon } from "./project/notified-icon"
import { NotionIcon } from "./project/notion-icon"
import { OnePasswordIcon } from "./project/onepassword-icon"
import { OpenAIIcon } from "./project/openai-icon"
import { PageIcon } from "./project/page-icon"
import { PaintIcon } from "./project/paint-icon"
import { PalmTreeIcon } from "./project/palmtree-icon"
import { PhoneIcon } from "./project/phone-icon"
import { PieChartIcon } from "./project/pie-chart-icon"
import { PillsIcon } from "./project/pills-icon"
import { PinIcon } from "./project/pin-icon"
import { PingPongIcon } from "./project/pingpong-icon"
import { PizzaIcon } from "./project/pizza-icon"
import { PointerIcon } from "./project/pointer-icon"
import { PokerCardIcon } from "./project/pokercard-icon"
import { PolicyIcon } from "./project/policy-icon"
import { PresentIcon } from "./project/present-icon"
import { ProcessIcon } from "./project/process-icon"
import { ProjectIcon } from "./project/project-icon"
import { QuestionMarkIcon } from "./project/questionmark-icon"
import { RadarIcon } from "./project/radar-icon"
import { RamenIcon } from "./project/ramen-icon"
import { RampIcon } from "./project/ramp-icon"
import { RankIcon } from "./project/rank-icon"
import { RecycleIcon } from "./project/recycle-icon"
import { RefreshIcon } from "./project/refresh-icon"
import { ReportIcon } from "./project/report-icon"
import { ResolvedIcon } from "./project/resolved-icon"
import { ResolvedChatIcon } from "./project/resolvedchat-icon"
import { RobotIcon } from "./project/robot-icon"
import { RocketIcon } from "./project/rocket-icon"
import { RoutingIcon } from "./project/routing-icon"
import { RunnerIcon } from "./project/runner-icon"
import { SafetyKitIcon } from "./project/safetykit-icon"
import { ScissorsIcon } from "./project/scissors-icon"
import { SearchIcon } from "./project/search-icon"
import { SendIcon } from "./project/send-icon"
import { SentryIcon } from "./project/sentry-icon"
import { ServerIcon } from "./project/server-icon"
import { ShieldIcon } from "./project/shield-icon"
import { ShipIcon } from "./project/ship-icon"
import { ShopIcon } from "./project/shop-icon"
import { ShrugIcon } from "./project/shrug-icon"
import { SignIcon } from "./project/sign-icon"
import { SignatureIcon } from "./project/signature-icon"
import { SkullIcon } from "./project/skull-icon"
import { SlackIcon } from "./project/slack-icon"
import { SmallLockIcon } from "./project/smalllock-icon"
import { SoccerBallIcon } from "./project/soccerball-icon"
import { SolanaIcon } from "./project/solana-icon"
import { SoundIcon } from "./project/sound-icon"
import { SoundMutedIcon } from "./project/soundmuted-icon"
import { SouthAmericaIcon } from "./project/south-america-icon"
import { SpacesIcon } from "./project/spaces-icon"
import { SpeakerIcon } from "./project/speaker-icon"
import { SpeedometerIcon } from "./project/speedometer-icon"
import { SpreadsheetIcon } from "./project/spreadsheet-icon"
import { StadiumIcon } from "./project/stadium-icon"
import { StarredIcon } from "./project/starred-icon"
import { StopwatchIcon } from "./project/stopwatch-icon"
import { StormIcon } from "./project/storm-icon"
import { SubgroupIcon } from "./project/subgroup-icon"
import { SubscribeIcon } from "./project/subscribe-icon"
import { SunIcon } from "./project/sun-icon"
import { SurferIcon } from "./project/surfer-icon"
import { TabletIcon } from "./project/tablet-icon"
import { TaxiIcon } from "./project/taxi-icon"
import { TeamIcon } from "./project/team-icon"
import { TeeShirtIcon } from "./project/tee-shirt-icon"
import { TennisBallIcon } from "./project/tennisball-icon"
import { TerminalIcon } from "./project/terminal-icon"
import { TextBlockIcon } from "./project/textblock-icon"
import { TextParagraphIcon } from "./project/textparagraph-icon"
import { ThumbsDownIcon } from "./project/thumbs-down-icon"
import { ThumbsUpIcon } from "./project/thumbs-up-icon"
import { TowerIcon } from "./project/tower-icon"
import { TrafficLightIcon } from "./project/trafficlight-icon"
import { TrainIcon } from "./project/train-icon"
import { TramIcon } from "./project/tram-icon"
import { TrashIcon } from "./project/trash-icon"
import { TreeIcon } from "./project/tree-icon"
import { UmbrellaIcon } from "./project/umbrella-icon"
import { UnhappyFaceIcon } from "./project/unhappy-face-icon"
import { UnionIcon } from "./project/union-icon"
import { UsersIcon } from "./project/users-icon"
import { VideoIcon } from "./project/video-icon"
import { ViewFinderIcon } from "./project/viewfinder-icon"
import { VisionProIcon } from "./project/visionpro-icon"
import { WallIcon } from "./project/wall-icon"
import { WatchIcon } from "./project/watch-icon"
import { WindTurbineIcon } from "./project/wind-turbine-icon"
import { WorldIcon } from "./project/world-icon"
import { WrenchIcon } from "./project/wrench-icon"
import { WriteIcon } from "./project/write-icon"
import { WritingAIIcon } from "./project/writingai-icon"
import { ZapierIcon } from "./project/zapier-icon"
import { ZendeskIcon } from "./project/zendesk-icon"

export { ProjectIconKeys }

export const ProjectIcons: Record<ProjectIconKeys, IconType> = {
	Accessibility: AccessibilityIcon,
	Africa: AfricaIcon,
	Ai: AiIcon,
	AiApp: AiAppIcon,
	AiDocument: AiDocumentIcon,
	Airplane: AirplaneIcon,
	AirTag: AirTagIcon,
	Alert: AlertIcon,
	AlarmClock: AlarmClockIcon,
	AmericanFootBall: AmericanFootBallIcon,
	Anchor: AnchorIcon,
	Android: AndroidIcon,
	Apple: AppleIcon,
	Asia: AsiaIcon,
	Asterisk: AsteriskIcon,
	Attachment: AttachmentIcon,
	Australia: AustraliaIcon,
	Auth0: Auth0Icon,
	Bandage: BandageIcon,
	Bank: BankIcon,
	BarChart: BarChartIcon,
	Basket: BasketIcon,
	Basketball: BasketballIcon,
	Battery: BatteryIcon,
	Bed: BedIcon,
	Bike: BikeIcon,
	Binocular: BinocularIcon,
	Bitcoin: BitcoinIcon,
	Blockquote: BlockquoteIcon,
	Bluetooth: BluetoothIcon,
	Bolt: BoltIcon,
	Bones: BonesIcon,
	Boombox: BoomboxIcon,
	Book: BookIcon,
	Bookmark: BookmarkIcon,
	BookOpen: BookOpenIcon,
	BowlingBall: BowlingBallIcon,
	Box: BoxIcon,
	BoxOpen: BoxOpenIcon,
	Brain: BrainIcon,
	Brick: BrickIcon,
	Briefcase: BriefcaseIcon,
	Brush: BrushIcon,
	Bucket: BucketIcon,
	Bug: BugIcon,
	Burger: BurgerIcon,
	Bus: BusIcon,
	Calculator: CalculatorIcon,
	Calendar: CalendarIcon,
	Camera: CameraIcon,
	CameraAi: CameraAiIcon,
	Car: CarIcon,
	CarPool: CarPoolIcon,
	Cart: CartIcon,
	Chart: ChartIcon,
	Chat: ChatIcon,
	Checklist: ChecklistIcon,
	Chemist: ChemistIcon,
	Chip: ChipIcon,
	Chrome: ChromeIcon,
	ClickButton: ClickButtonIcon,
	Clock: ClockIcon,
	ClockOutline: ClockOutlineIcon,
	ClothHanger: ClothHangerIcon,
	Cloud: CloudIcon,
	CodeBlock: CodeBlockIcon,
	Coffee: CoffeeIcon,
	Comment: CommentIcon,
	Comodore: ComodoreIcon,
	Compass: CompassIcon,
	Computer: ComputerIcon,
	Cone: ConeIcon,
	Connected: ConnectedIcon,
	ConstructionBarrier: ConstructionBarrierIcon,
	Conversation: ConversationIcon,
	Cookie: CookieIcon,
	Crane: CraneIcon,
	CreditCard: CreditCardIcon,
	Cross: CrossIcon,
	Crown: CrownIcon,
	CrystalBall: CrystalBallIcon,
	Cube: CubeIcon,
	Dashboard: DashboardIcon,
	Database: DatabaseIcon,
	DesignTools: DesignToolsIcon,
	DesktopWindow: DesktopWindowIcon,
	Dice: DiceIcon,
	Dino: DinoIcon,
	Direction: DirectionIcon,
	Discord: DiscordIcon,
	Dna: DnaIcon,
	Dollar: DollarIcon,
	DollarBill: DollarBillIcon,
	Dumbbell: DumbbellIcon,
	Edge: EdgeIcon,
	Education: EducationIcon,
	ElectricPlug: ElectricPlugIcon,
	Email: EmailIcon,
	Eraser: EraserIcon,
	Ethereum: EthereumIcon,
	Euro: EuroIcon,
	Europe: EuropeIcon,
	Extinguisher: ExtinguisherIcon,
	Face: FaceIcon,
	FaceFlatSmile: FaceFlatSmileIcon,
	FaceHeartEyes: FaceHeartEyesIcon,
	FaceId: FaceIdIcon,
	FaceMask: FaceMaskIcon,
	FaceMonocle: FaceMonocleIcon,
	FaceStarEyes: FaceStarEyesIcon,
	FaceSunglasses: FaceSunglassesIcon,
	FaceSurprise: FaceSurpriseIcon,
	FaceTired: FaceTiredIcon,
	FaceTongue: FaceTongueIcon,
	Factory: FactoryIcon,
	Favorite: FavoriteIcon,
	Feather: FeatherIcon,
	Figma: FigmaIcon,
	Fire: FireIcon,
	Firefox: FirefoxIcon,
	Flashlight: FlashlightIcon,
	FloppyDisk: FloppyDiskIcon,
	Flower: FlowerIcon,
	Folder: FolderIcon,
	FootPrint: FootPrintIcon,
	Garage: GarageIcon,
	Gears: GearsIcon,
	GitHub: GitHubIcon,
	GitLab: GitLabIcon,
	Golf: GolfIcon,
	Hack: HackIcon,
	Health: HealthIcon,
	Hear: HearIcon,
	Heart: HeartIcon,
	Home: HomeIcon,
	Hourglass: HourglassIcon,
	Image: ImageIcon,
	Inbox: InboxIcon,
	Intercom: IntercomIcon,
	Jersey: JerseyIcon,
	Joystick: JoystickIcon,
	Judge: JudgeIcon,
	Label: LabelIcon,
	Ladder: LadderIcon,
	Leaf: LeafIcon,
	LightBulb: LightBulbIcon,
	Linear: LinearIcon,
	Link: LinkIcon,
	LockerRoom: LockerRoomIcon,
	Lock: LockIcon,
	Mac: MacIcon,
	MacOS: MacOSIcon,
	MagicWand: MagicWandIcon,
	Magnet: MagnetIcon,
	Mask: MaskIcon,
	Megaphone: MegaphoneIcon,
	Meta: MetaIcon,
	Mic: MicIcon,
	MilitaryTruck: MilitaryTruckIcon,
	MobilePhone: MobilePhoneIcon,
	Modem: ModemIcon,
	MoneyStack: MoneyStackIcon,
	Moon: MoonIcon,
	Mountain: MountainIcon,
	MovingStaircase: MovingStaircaseIcon,
	MusicKey: MusicKeyIcon,
	MusicTape: MusicTapeIcon,
	Network: NetworkIcon,
	NorthAmerica: NorthAmericaIcon,
	NotePad: NotePadIcon,
	Notified: NotifiedIcon,
	Notion: NotionIcon,
	OnePassword: OnePasswordIcon,
	OpenAI: OpenAIIcon,
	Page: PageIcon,
	PalmTree: PalmTreeIcon,
	Paint: PaintIcon,
	Phone: PhoneIcon,
	PieChart: PieChartIcon,
	Pills: PillsIcon,
	Pin: PinIcon,
	PingPong: PingPongIcon,
	Pizza: PizzaIcon,
	Pointer: PointerIcon,
	Policy: PolicyIcon,
	PokerCard: PokerCardIcon,
	Present: PresentIcon,
	Process: ProcessIcon,
	Project: ProjectIcon,
	Radar: RadarIcon,
	Ramen: RamenIcon,
	Rank: RankIcon,
	Recycle: RecycleIcon,
	Refresh: RefreshIcon,
	Robot: RobotIcon,
	Rocket: RocketIcon,
	Routing: RoutingIcon,
	Runner: RunnerIcon,
	SafetyKit: SafetyKitIcon,
	Scissors: ScissorsIcon,
	Search: SearchIcon,
	Send: SendIcon,
	Server: ServerIcon,
	Sentry: SentryIcon,
	Shield: ShieldIcon,
	Ship: ShipIcon,
	Shop: ShopIcon,
	Shrug: ShrugIcon,
	Sign: SignIcon,
	Signature: SignatureIcon,
	Skull: SkullIcon,
	Slack: SlackIcon,
	SoccerBall: SoccerBallIcon,
	Solana: SolanaIcon,
	Sound: SoundIcon,
	SouthAmerica: SouthAmericaIcon,
	Spaces: SpacesIcon,
	Speaker: SpeakerIcon,
	Spreadsheet: SpreadsheetIcon,
	Stadium: StadiumIcon,
	Storm: StormIcon,
	Subgroup: SubgroupIcon,
	Subscribe: SubscribeIcon,
	Sun: SunIcon,
	Surfer: SurferIcon,
	Tablet: TabletIcon,
	Taxi: TaxiIcon,
	Team: TeamIcon,
	TeeShirt: TeeShirtIcon,
	TennisBall: TennisBallIcon,
	Terminal: TerminalIcon,
	TextBlock: TextBlockIcon,
	TextParagraph: TextParagraphIcon,
	ThumbsDown: ThumbsDownIcon,
	ThumbsUp: ThumbsUpIcon,
	Tower: TowerIcon,
	TrafficLight: TrafficLightIcon,
	Train: TrainIcon,
	Tram: TramIcon,
	Tree: TreeIcon,
	Trash: TrashIcon,
	Umbrella: UmbrellaIcon,
	UnhappyFace: UnhappyFaceIcon,
	Union: UnionIcon,
	Users: UsersIcon,
	Video: VideoIcon,
	ViewFinder: ViewFinderIcon,
	VisionPro: VisionProIcon,
	Wall: WallIcon,
	Watch: WatchIcon,
	WindTurbine: WindTurbineIcon,
	World: WorldIcon,
	Wrench: WrenchIcon,
	Write: WriteIcon,
	WritingAI: WritingAIIcon,
	Zapier: ZapierIcon,
	Zendesk: ZendeskIcon,
	CustomView: CustomViewIcon,
	Initiative: InitiativeIcon,
	IssueStatusBacklog: IssueStatusBacklogIcon,
	IssueStatusDone: IssueStatusDoneIcon,
	IssueStatusReview: IssueStatusReviewIcon,
	IssueStatusStarted: IssueStatusStartedIcon,
	IssueStatusTodo: IssueStatusTodoIcon,
	IssueStatusTriage: IssueStatusTriageIcon,
	MilestoneNone: MilestoneNoneIcon,
	MilestoneStatusDone: MilestoneStatusDoneIcon,
	MilestoneStatusPlanned: MilestoneStatusPlannedIcon,
	MilestoneStatusStarted: MilestoneStatusStartedIcon,
	MyIssues: MyIssuesIcon,
	Anthropic: AnthropicIcon,
	Claude: ClaudeIcon,
	Cursor: CursorIcon,
	Ramp: RampIcon,
	AiWriting: AiWritingIcon,
	AlarmDelete: AlarmDeleteIcon,
	Alarm: AlarmIcon,
	Anonymous: AnonymousIcon,
	Astronaut: AstronautIcon,
	BarGraph: BarGraphIcon,
	ChatLine: ChatLineIcon,
	Biscuit: BiscuitIcon,
	Diagram: DiagramIcon,
	ExclamationMark: ExclamationMarkIcon,
	Flag: FlagIcon,
	GooglePlay: GooglePlayIcon,
	MicrosoftTeams: MicrosoftTeamsIcon,
	QuestionMark: QuestionMarkIcon,
	Report: ReportIcon,
	ResolvedChat: ResolvedChatIcon,
	Resolved: ResolvedIcon,
	SmallLock: SmallLockIcon,
	SoundMuted: SoundMutedIcon,
	Speedometer: SpeedometerIcon,
	Starred: StarredIcon,
	Stopwatch: StopwatchIcon,
	Automation: AutomationIcon,
}
